<template>
  <div class="sankey-container">
    <div class="title-box">
      {{ props.title }}

      <div class="subtitle">
        {{ props.subtitle }}
      </div>
    </div>
    <v-chart class="sankey-box" :option="chart"></v-chart>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, defineProps } from 'vue';
const props = defineProps({
  data: {
    type: Object,
    default: () => {
      //
    },
  },
  title: {
    type: String,
    default: '',
  },
  color: {
    type: Array,
    default: () => [],
  },
  subtitle: {
    type: String,
    default: '',
  },
});

const chart = ref<any>({});

onMounted(() => {
  const calcSize = parseInt(getComputedStyle(window.document.documentElement)['font-size'], 10);

  chart.value = {
    tooltip: {
      trigger: 'item',
      triggerOn: 'mousemove',
      formatter: (params) => {
        const { data } = params;
        return `${data.value || ''}`;
        // if (data?.source && data?.target) {
        // return `${data.source.replace('source-', '')} - ${data.target.replace('target-', '')}: ${data.value}`;
        //   return `${data.value || ''}`;
        // } else {
        //   return `${data.count || ''}`;
        // }
      },
      textStyle: {
        fontSize: (12 / 192) * calcSize,
        padding: (5 / 192) * calcSize,
      },
    },
    series: {
      type: 'sankey',
      // layout: 'none',
      emphasis: {
        focus: 'adjacency',
      },
      width: '60%',
      height: '80%',
      draggable: false,
      nodeGap: (12 / 192) * calcSize,
      // nodeWidth: 12,
      left: 'center',
      itemStyle: {
        // borderWidth: 1
      },
      data: [
        ...props.data.providersNodes.map((it: any, index: number) => {
          return {
            name: 'source-' + it.name,
            label: {
              show: true,
              position: 'left',
              formatter: (params) => params.name.replace('source-', ''),
              fontSize: (12 / 192) * calcSize,
            },

            itemStyle: {
              color: props.color[index],
            },
            value: it.count,
          };
        }),
        ...props.data.consumersNodes.map((it: any, index: number) => {
          return {
            name: 'target-' + it.name,
            label: {
              show: true,
              position: 'right',
              formatter: (params) => params.name.replace('target-', ''),
              fontSize: (12 / 192) * calcSize,
            },
            itemStyle: {
              color: props.color[index],
            },
            value: it.count,
          };
        }),
      ],
      links: props.data.links.map((it: any, index: number) => {
        return {
          source: 'source-' + it.source,
          target: 'target-' + it.target,
          value: it.value,
          emphasis: {
            edgeLabel: {
              // show: true,
            },
          },
          lineStyle: {
            color: 'gradient',
            curveness: 0.5,
            opacity: 0.3,
          },
          edgeLabel: {
            show: false,
            formatter: () => {
              return `${it.value}`;
            },
            fontSize: (24 / 192) * calcSize,
            // fontWeight: 700,
            // color: '#000',
          },
        };
      }),
    },
  };
});
</script>

<style lang="scss" scoped>
.sankey-container {
  // height: 100%;
  // display: inline-block;
  // background-color: #fff;
  padding-bottom: 20px;
  // text-align: center;

  .title-box {
    font-size: 18px;
    font-weight: 700;
    margin-top: 0;
    padding: 25px;
    user-select: none;
    cursor: normal;

    .subtitle {
      font-size: 12px;
      font-weight: 400;
      color: #999;
    }
  }

  .sankey-box {
    // margin-top
    // width: 80%;
    // height: 85%;
    // display: inline-block;
  }
}
</style>
